// extracted by mini-css-extract-plugin
module.exports = {"graph":"Dashoverview_graph__26GHI","title":"Dashoverview_title__2uKsR","gContainer":"Dashoverview_gContainer__2I7Qv"};